<template>
  <v-list-item @click="detail(picklist)" class="picklist-item py-5 ">
    <div class="item-body">
      <div class="item-title">
        <div class="item-title-inner">
            <v-list-item-title class="text-truncate max-width-text" >
            <span v-for="tour in picklist.Tour" :key="tour.Tournr">
              {{ tour.KfzKennzeichen }}
            </span>
            <span v-if="!picklist.Tour.length">
              {{ picklist.allPositions[0].Name }}
            </span>
          </v-list-item-title>
          <v-list-item-subtitle v-if="!picklist.Tour.length">
            {{ picklist.allPositions[0].Belegnr }}
          </v-list-item-subtitle>
        </div>
        <div>
          <v-list-item-subtitle>
            <div>
              {{ picklist.ErstelltamDate }} {{ picklist.ErstelltamTime }}
            </div>
            <div class="text-end">
              <small>#{{ picklist.Picklistnr }}</small>
            </div>
          </v-list-item-subtitle>
        </div>
      </div>
    </div>
    <picklist-progress
      :picklist="picklist"
    />
  </v-list-item>
</template>

<script lang="ts">
import PicklistProgress from './PicklistProgress.vue';
import router from '@/router';
import {defineComponent} from 'vue';
import Picklist, {ApiPicklistState} from '@/model/Picklist';

export default defineComponent({
  name: 'PicklistListItem',
  components: {PicklistProgress},
  props: {
    picklist: {
      type: Picklist,
      required: true,
    },
  },
  setup() {
    return {
      detail(item: Picklist) {
        router.push({name: 'picklist_detail', params: {id: item.Picklistnr.toString()}}).catch(console.error);
      },
      PicklistState: ApiPicklistState,
    };
  },
});

</script>
<style lang="scss" scoped>

.v-chip .v-icon {
  font-size: 16px;
}

.item-body {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  .item-title {
    display: flex;
    justify-content: space-between;
    flex: 1;
  }
}
.item-operator-info {
  display: flex;
  justify-content: stretch;
  align-items: center;
  text-align: center;
  border-top-left-radius: 50px;
  border-bottom-left-radius: 50px;
  flex: auto;
  .v-chip__content {
    display: block;
  }
  .primary {
    color: #fff;
  }
  .v-chip {
    text-align: left;
  }
  .item-operator-info-inner {
    display: flex;
    align-items: center;
    justify-content: stretch;
    flex: auto;
    .v-list-item__subtitle {
      font-size: 12px;
      line-height: 1;
      overflow: visible;
    }
  }
}
.item-footer {
  display: flex;
  justify-content: space-between;
  padding-top: 5px;
}

.max-width-text {
  @media (max-width: 600px) {
    max-width: 200px;
  }
}

.v-list-item {
  display: block;
  overflow: hidden;
}
.v-chip.theme--light {
  &.red {
    color: #fff;
  }
}
.v-chip.v-size--default {
  font-size: 12px;
}
.item-progress-bar {
  display: flex;
  align-items: center;
  flex: 1;
  width: 100%;
}

</style>
